// Documents attached to a container or a shipment (03 §3.4a, 04 §4.4): the bill of lading, the
// customs entry, the invoice, the delivery order. The file itself is an upload (`uploads/{uid}/…`,
// 07 §7.3); this record says what it is and what it is about. Server-written by `attachDocument`.
import { z } from 'zod';

export const DOCUMENT_TYPES = [
  'bl',
  'awb',
  'telex_release',
  'arrival_notice',
  'delivery_order',
  'customs_entry',
  'customs_release',
  'invoice',
  'packing_list',
  'delivery_note',
  'pod',
  'other',
] as const;
export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export const DOCUMENT_TYPE_LABELS: Readonly<Record<DocumentType, string>> = {
  bl: 'Bill of lading',
  awb: 'Air waybill',
  telex_release: 'Telex release',
  arrival_notice: 'Arrival notice',
  delivery_order: 'Delivery order',
  customs_entry: 'Customs entry',
  customs_release: 'Customs release',
  invoice: 'Invoice',
  packing_list: 'Packing list',
  delivery_note: 'Delivery note',
  pod: 'Proof of delivery',
  other: 'Other',
};

export const DOCUMENT_SUBJECT_KINDS = ['container', 'shipment'] as const;
export type DocumentSubjectKind = (typeof DOCUMENT_SUBJECT_KINDS)[number];

/** `containers/{id}/documents/{doc_…}` and `shipments/{trackingNo}/documents/{doc_…}`. */
export const documentDocSchema = z.object({
  id: z.string(),
  docType: z.enum(DOCUMENT_TYPES),
  title: z.string(),
  path: z.string(),
  reference: z.string().default(''),
  amountMinor: z.number().int().nonnegative().optional(),
  currency: z.string().length(3).optional(),
  note: z.string().default(''),
  addedBy: z.string(),
  addedAt: z.string(),
  commandId: z.string(),
});
export type DocumentDoc = z.infer<typeof documentDocSchema>;
